import { Nft } from "@/api/nfts/types";
import React from "react";
import { RadioButton } from "@/app/(components)/Basic/RadioButton";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";

interface Props {
  idPrefix: string;
  nfts: Nft[];
  selected: string | undefined;
  setSelected: (id: string) => void;
  subtitle: string;
}
const AttachNftsList = ({
  idPrefix,
  nfts,
  selected,
  setSelected,
  subtitle,
}: Props) => {
  return (
    <>
      <h4 className="mb-4 text-body-4">{subtitle}</h4>
      <div className="flex flex-col max-h-[300px] overflow-y-auto thin-custom-scroll -mr-5 pr-5">
        {nfts &&
          nfts.map((art, index) => {
            return (
              <React.Fragment key={index}>
                <RadioButton
                  id={`${idPrefix}-${art.id}`}
                  radioButtonOnRightSide
                  label={
                    <div
                      key={index}
                      className="flex justify-between items-center endemic:text-invert"
                    >
                      <div className="w-[60px] h-[60px] relative mr-6">
                        <ImageTypeHandler
                          src={art.thumbnail || art.originalImage}
                          placeholder={art.placeholder}
                          alt={art.name}
                          type={art.mediaType}
                          fill
                          className="object-cover"
                          onClick={() => setSelected(art.id)}
                        />
                      </div>
                      <span className="font-light">{art.name}</span>
                    </div>
                  }
                  value={art.id}
                  selected={selected}
                  onChange={(event) => setSelected(event.target.value)}
                  className={"px-0 border-b"}
                  removeHover
                  removePadding
                  labelClass="flex-row w-full"
                />
              </React.Fragment>
            );
          })}
      </div>
    </>
  );
};

export default AttachNftsList;
